import {performHttpRequest} from "../http";

export async function getWfsInfo(bookmarkPresentationID, featureID) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/bookmarkpresentation/' + bookmarkPresentationID + '/info/' + featureID,
        'GET'
    )
}

export async function getWfsInfoByDomainID(domainID, presentationID, featureID) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + domainID + '/presentation/' + presentationID + '/info/' + featureID,
        'GET'
    )
}

export async function getWfsInfoByDomainIDAndColumn(domainID, presentationID, featureID, column) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + domainID + '/presentation/' + presentationID + '/info/' + featureID + '/column/' + column,
        'GET'
    )
}
